import BasedHeader from "../components/BasedHeader";
import { useContract, useAddress, useContractRead, Web3Button } from "@thirdweb-dev/react";
import { useState } from "react";
import { useToast } from "../components/ui/use-toast";
import { contractConst } from "../consts/parameters";
import { ethers } from "ethers";

export default function Mint() {
  const { contract } = useContract(contractConst);
  const address = useAddress();
  const { toast } = useToast();
  const [quantity, setQuantity] = useState(1);

  const { data: totalMinted } = useContractRead(contract, "totalMinted");
  const { data: maxSupply } = useContractRead(contract, "MAX_SUPPLY");
  const { data: mintPrice } = useContractRead(contract, "MINT_PRICE");
  const { data: mintEnabled } = useContractRead(contract, "mintEnabled");

  const formattedTotalMinted = totalMinted ? totalMinted.toString() : "0";
  const formattedMaxSupply = maxSupply ? maxSupply.toString() : "0";
  const formattedMintPrice = mintPrice ? ethers.utils.formatEther(mintPrice) : "0";
  const remainingSupply = maxSupply && totalMinted ? maxSupply.sub(totalMinted).toNumber() : 0;

  // Debugging logs (remove in production if desired)
  console.log("Contract State:", {
    totalMinted: formattedTotalMinted,
    maxSupply: formattedMaxSupply,
    mintPrice: mintPrice?.toString(),
    mintEnabled,
    remainingSupply,
  });

  return (
    <>
      <BasedHeader />
      <div className="min-h-screen bg-gradient-radial from-gray-900 via-black to-black text-white pt-32">
        <div className="container mx-auto px-4 pb-20 flex flex-col items-center">
          <h1 className="text-7xl font-bold mb-2 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-500 to-blue-600 text-center hover-float">
            Mint Your Ponk
          </h1>
          <div className="max-w-xl mx-auto glass rounded-2xl p-8 w-full">
            <div className="grid grid-cols-2 gap-6 mb-10">
              <div className="glass rounded-2xl p-6">
                <p className="text-gray-400 mb-2">Total Minted</p>
                <div className="flex items-baseline gap-2">
                  <p className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-violet-400 to-purple-600">
                    {formattedTotalMinted}
                  </p>
                  <p className="text-lg text-gray-500">/ {formattedMaxSupply}</p>
                </div>
              </div>
              <div className="glass rounded-2xl p-6">
                <p className="text-gray-400 mb-2">Mint Price</p>
                <p className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-violet-400 to-purple-600">
                  {formattedMintPrice} ETH
                </p>
              </div>
              <div className="col-span-2 flex justify-between items-center">
                <div className="glass rounded-2xl p-6">
                  <p className="text-gray-400 mb-2">Remaining Supply</p>
                  <p className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-violet-400 to-purple-600">
                    {remainingSupply}
                  </p>
                </div>
                <div className="glass rounded-2xl p-6">
                  <label className="block text-gray-400 mb-4 text-lg text-center">Select Quantity</label>
                  <div className="flex items-center justify-center gap-6">
                    <button
                      className="glass hover:bg-white/10 text-violet-400 hover:text-violet-300 w-12 h-12 rounded-xl transition-colors duration-200 text-2xl font-bold"
                      onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    >
                      -
                    </button>
                    <span className="text-3xl font-bold text-white/90 w-16 text-center">{quantity}</span>
                    <button
                      className="glass hover:bg-white/10 text-violet-400 hover:text-violet-300 w-12 h-12 rounded-xl transition-colors duration-200 text-2xl font-bold"
                      onClick={() => setQuantity(Math.min(remainingSupply, quantity + 1))}
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center mt-6">
              <Web3Button
                contractAddress={contractConst}
                action={async (contract) => {
                  console.log("Minting with:", {
                    quantity,
                    mintPrice: mintPrice?.toString(),
                    totalValue: mintPrice?.mul(quantity).toString(),
                  });
                  await contract.call("mint", [quantity], {
                    value: mintPrice?.mul(quantity).toString(), // Use BigNumber for precision
                  });
                }}
                className="w-2/3 !bg-gradient-to-r !from-violet-500 !to-purple-600 !rounded-xl !py-4 !text-lg !font-bold hover:!opacity-90 transition-opacity"
                isDisabled={!address || !mintEnabled || !mintPrice || remainingSupply < quantity}
                onSuccess={() =>
                  toast({
                    title: "Successfully minted!",
                    description: `You minted ${quantity} Ponk${quantity > 1 ? "s" : ""}!`,
                  })
                }
                onError={(error) =>
                  toast({
                    title: "Error minting",
                    description: error.message,
                    variant: "destructive",
                  })
                }
              >
                {!address
                  ? "Connect Wallet"
                  : !mintEnabled
                  ? "Minting Not Live"
                  : remainingSupply < quantity
                  ? "Not Enough Supply"
                  : "Mint Now"}
              </Web3Button>
            </div>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto text-center leading-relaxed font-light mt-6">
              Join the Based Ponks revolution. Mint your unique digital artifact on Base Network.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}